/** @jsxImportSource davaux/client */
import { createSignal } from 'davaux/client'

function EyeIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='1em'
      height='1em'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <path d='M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z' />
      <circle cx='12' cy='12' r='3' />
    </svg>
  )
}

function EyeOffIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='1em'
      height='1em'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' />
      <line x1='1' y1='1' x2='23' y2='23' />
    </svg>
  )
}

export default function PasswordInput({
  id,
  label,
  description,
  error,
  required,
  withAsterisk,
  disabled,
  value: initialValue = '',
  placeholder,
  name,
  className = '',
}: {
  id?: string
  label?: string
  description?: string
  error?: string
  required?: boolean
  withAsterisk?: boolean
  disabled?: boolean
  value?: string
  placeholder?: string
  name?: string
  className?: string
}) {
  const [visible, setVisible] = createSignal(false)
  const hasAsterisk = required || withAsterisk
  const hasError = !!error

  return (
    <div
      class={`dv-input-wrapper dv-password-input${className ? ` ${className}` : ''}`}
      data-disabled={disabled || undefined}
      data-error={hasError || undefined}
    >
      {label && (
        <label class='dv-input-label' for={id} data-required={hasAsterisk || undefined}>
          {label}
          {hasAsterisk && (
            <span class='dv-input-asterisk' aria-hidden='true'>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      {description && <p class='dv-input-description'>{description}</p>}
      <div class='dv-password-input-wrapper'>
        <input
          class='dv-input'
          type={() => (visible() ? 'text' : 'password')}
          id={id}
          name={name}
          value={initialValue}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          data-error={hasError || undefined}
        />
        <button
          type='button'
          class='dv-password-input-toggle'
          onClick={() => setVisible(!visible())}
          aria-label={() => (visible() ? 'Hide password' : 'Show password')}
          disabled={disabled}
          tabIndex={-1}
        >
          {() => (visible() ? <EyeOffIcon /> : <EyeIcon />)}
        </button>
      </div>
      {hasError && <p class='dv-input-error'>{error}</p>}
    </div>
  )
}
